import MInput from "./MInput.vue";
export default MInput;
